export namespace HotelModuleTest {
  export class Configurator implements Persistance {
    showSupplierMetaData: boolean;
    showPublicPrices: boolean;
    showUseCredits: boolean;
    redirectPayNowBookingOffer: boolean;
    starRatingSurveyDisplayFrequencies: StarRatingSurveyDisplayFrequencies;
    searchWithKids: boolean;

    constructor(persistance?: Persistance) {
      this.showSupplierMetaData = persistance
        ? persistance.showSupplierMetaData
        : false;
      this.showPublicPrices = persistance
        ? persistance.showPublicPrices
        : false;
      this.showUseCredits = true;
      this.redirectPayNowBookingOffer = persistance
        ? persistance.redirectPayNowBookingOffer
        : true;
      this.starRatingSurveyDisplayFrequencies =
        persistance?.starRatingSurveyDisplayFrequencies
          ? persistance.starRatingSurveyDisplayFrequencies
          : StarRatingSurveyDisplayFrequencies.Disabled;
      this.searchWithKids = persistance ? persistance.searchWithKids : false;
    }
  }

  export interface Persistance {
    showSupplierMetaData: boolean;
    showPublicPrices: boolean;
    showUseCredits: boolean;
    redirectPayNowBookingOffer: boolean;
    starRatingSurveyDisplayFrequencies: StarRatingSurveyDisplayFrequencies;
    searchWithKids: boolean;
  }

  export enum StarRatingSurveyDisplayFrequencies {
    Once = 'once',
    EverySearch = 'every_search',
    Disabled = 'disabled',
  }
}
